module.exports = __webpack_public_path__ + "static/img/fullscreen-image_interested-in-becoming-a-partner_600.797617c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_interested-in-becoming-a-partner_600.png
// module id = +pOF
// module chunks = 0